import { render, staticRenderFns } from "./ThemePreview.vue?vue&type=template&id=c06a3882&scoped=true&"
import script from "./ThemePreview.vue?vue&type=script&lang=js&"
export * from "./ThemePreview.vue?vue&type=script&lang=js&"
import style0 from "./ThemePreview.vue?vue&type=style&index=0&id=c06a3882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06a3882",
  null
  
)

export default component.exports